<template>
	<div class="menu">
		<v-btn class="menu-btn" flat dark v-on:click="is_drop = !is_drop;"><v-icon>menu</v-icon></v-btn>
		<transition>	
			<div class="menu-list-group" v-if="is_drop">
				<v-sheet light color="#ECEFF1">
					<v-layout row wrap align-center pa-2 ma-0 class="menu-list-header">
						<v-flex xs2>
							<v-icon>account_circle</v-icon>
						</v-flex>
						<v-flex xs8 class="menu-list-title">
							{{loginMemberName}}
						</v-flex>
						<v-flex xs2>
							<v-btn depressed fab small flat >
								<v-icon>more_vert</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
				</v-sheet>
				<v-btn flat block large light class="menu-list-item ma-0" v-if="isTChart" v-on:click="onClickMoveToTList">
					リストへ
				</v-btn>
				<v-btn flat block large light class="menu-list-item ma-0" v-if="isTList" v-on:click="onClickMoveToTChart">
					チャートへ
				</v-btn>
				<v-btn flat block large light class="menu-list-item ma-0">
					ログアウト
				</v-btn>
			</div>
		</transition>
	</div>
</template>

<script>
import MouseState from '../classes/MouseState';
import MouseStateMachine from '../classes/MouseStateMachine';

export default {
	name: 'Menu',
	data(){
		const state_default = new MouseState({
				down: (e) => {
					let obj = e.targetTouches ? e.targetTouches[0] : e;
					if(obj.target.closest('.menu')){
						return ;
					}
					this.closeMenu();
				},
			});
		return {
			is_drop: false,
			menu_close: new MouseStateMachine(state_default),
		}
	},
	methods: {
		onClickMoveToTChart() {
			this.$router.push({
				name: 'GanttTimeBoardChart', 
			});
		},
		onClickMoveToTList() {
			this.$router.push({
				name: 'GanttTimeBoardList', 
			});
		},
		closeMenu: function() {
			this.is_drop = false;
		},
	},
	computed: {
		isTChart: function() {
			return this.$route.name === 'GanttTimeBoardChart';
		},
		isTList: function() {
			return this.$route.name === 'GanttTimeBoardList';
		},
		loginMemberName: function() {
			return this.$store.getters['loginUser'].name;
		},
	},
	mounted: function() {
		this.menu_close.bind(window);
	},
	beforeDestroy: function() {
		this.menu_close.unbind();
	},
}
</script>
<style>
	.menu {
		position: relative;
		height: 30px;
	}
	.menu-btn {
		height: 30px !important;
		margin: 0px;
	}
	.menu-list-group {
		position: absolute;
		top:30px;
		right: 0px;
		width: 300px;
		background-color: white;
		border:solid 1px #DFDFDF;
		border-bottom: none;
		z-index: 104;
	}
	.menu-list-header {
		min-height: 50px;
		font-size: 100%;
		font-weight: bolder;
		border-bottom:solid 2px #DFDFDF;
	}
	.menu-list-title {
		word-wrap: break-word;
	}
	.menu-list-item {
		display: flex;
		justify-content: center;
		height: 50px !important;
		border-bottom:solid 1px #DFDFDF;
	}
</style>
<style scoped>
	.v-enter-active, .v-leave-active {
		transition: all 0.3s;
	}
	.v-enter {
		transform: translateY(-10px);
	}
	.v-enter, .v-leave-to {
		opacity: 0;
	}
</style>

